import React, { useState } from 'react';
import './ContactSection.css';

function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    
    setTimeout(() => {
      setFormData({
        name: '',
        company: '',
        email: '',
        subject: '',
        message: ''
      });
      setSubmitted(false);
    }, 4000);
  };

  return (
    <section id="contact" className="contact-section">
      <div className="section-container">
        <div className="contact-wrapper">
          <div className="contact-info-block">
            <h2>Get in Touch</h2>
            <p className="contact-intro">
              We welcome inquiries from suppliers, distributors, and business partners. 
              Let's discuss how Northstar Bridge Commerce can support your wholesale operations.
            </p>

            <div className="contact-details">
              <div className="detail-item">
                <h4>Company</h4>
                <p>Northstar Bridge Commerce LLC</p>
              </div>
              <div className="detail-item">
                <h4>Business Type</h4>
                <p>Wholesale Trading & Online Retail Distribution</p>
              </div>
              <div className="detail-item">
                <h4>Registered Office</h4>
                <p>8 The Green, STE R, Dover, DE 19901, USA</p>
              </div>
              <div className="detail-item">
                <h4>Phone</h4>
                <p>
                  <a href="tel:+13023858016">+1 302 385 8016</a>
                </p>
              </div>
              <div className="detail-item">
                <h4>Email</h4>
                <p><a href="mailto:contact@northstarbridgeco.com">contact@northstarbridgeco.com</a></p>
              </div>
              <div className="detail-item">
                <h4>Business Hours</h4>
                <p>Monday – Friday: 9:00 AM – 5:00 PM EST</p>
              </div>
              <div className="detail-item">
                <p style={{fontSize: '0.9rem', color: '#6b7280', fontStyle: 'italic', marginTop: '1rem'}}>
                  For wholesale, supplier, and partnership inquiries, please contact us through our business email.
                </p>
              </div>
            </div>
          </div>

          <div className="contact-form-block">
            <h3>Send us a Message</h3>
            
            {submitted && (
              <div className="success-message">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Thank you for your inquiry. We'll be in touch soon.
              </div>
            )}

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="company">Company *</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                  placeholder="Your company name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="What is this regarding?"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Tell us more about your business needs..."
                  rows="5"
                ></textarea>
              </div>

              <button type="submit" className="submit-button">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
